import axiosInstance from 'api-services/api-client';

const UserService = {
  getUser: async (userId) => {
    const response = await axiosInstance.get(`/users/${userId}`);
    return response.data;
  },
  updateUser: async (userId, data) => {
    const response = await axiosInstance.patch(`/users/${userId}`, data);
    return response.data;
  },
};

export default UserService;
